import { FormControl, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";

import Colors from "../../../../../../../../../../global/Colors";
import Title from "../../../../../components/Title";
import { STRINGS } from "../../../../components/utils/strings";
import { useProCliStore } from "../../../../hooks/useProCliStore";

export default function TreatmentStatus({
  canEdit,
  title,
  index,
  fieldName,
  initialValue,
  updateProviderInfo,
  subTitle,
}) {
  const { providersData } = useProCliStore();

  const [treatment, setTreatment] = useState("");

  const isDisabled = canEdit ? false : true;

  const getTreatmentValue = (treatmentValue) => {
    return treatmentValue === STRINGS.TREATMENT_STATUS.COMPLETE ? true : false;
  };
  const handleSetTreatment = (event) => {
    const value = event.target.value;
    setTreatment(value);

    const boolValue = getTreatmentValue(value);

    let editableData = null;

    const existingFields = providersData.get(index).editableFields;
    if (boolValue === initialValue) {
      if (existingFields && Object.keys(existingFields).length > 1) {
        editableData = {
          ...existingFields,
        };
        console.log(editableData);
        delete editableData[fieldName];
        console.log(editableData);
      }
      const updatedData = new Map(providersData);
      updatedData.set(index, {
        ...updatedData.get(index),
        editableFields: editableData,
      });
      updateProviderInfo(updatedData);
      return;
    }
    editableData = {
      ...existingFields,
      [fieldName]: boolValue,
    };
    const updatedData = new Map(providersData);
    updatedData.set(index, {
      ...updatedData.get(index),
      editableFields: editableData,
    });
    updateProviderInfo(updatedData);
  };

  useEffect(() => {
    let finalValue;
    if (initialValue === null) {
      finalValue = STRINGS.NO_SELECTION;
    } else if (initialValue === true) {
      finalValue = STRINGS.TREATMENT_STATUS.COMPLETE;
    } else if (initialValue === false) {
      finalValue = STRINGS.TREATMENT_STATUS.TREATING;
    } else {
      finalValue = STRINGS.NO_SELECTION;
    }
    setTreatment(finalValue);
  }, [initialValue]);

  return (
    <div
      id="Provider-Tab-Treatment-Status"
      data-testid="Provider-Tab-Treatment-Status"
      className="w-full"
    >
      <div>
        <Title text={title} size={"text-xs"} horizontalPadding="pl-2" className="block w-full" />
        {subTitle && (
          <Title
            text={"(" + subTitle + ")"}
            size={"text-[0.65rem]"}
            color="text-gray-400"
            fontStyle="normal-case"
            horizontalPadding="pl-2"
          />
        )}
      </div>
      <FormControl sx={{ marginTop: "0.5rem", minWidth: 160, maxWidth: 500 }} size="small">
        <Select
          labelId="Provider-Tab-Treatment-Status-label"
          id="Provider-Tab-Treatment-Status-select"
          className="w-full"
          value={treatment}
          label={title}
          onChange={handleSetTreatment}
          sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
            "&.Mui-disabled": {
              backgroundColor: isDisabled ? Colors.gray[200] : Colors.white,
            },
            fontSize: "0.85rem",
            borderRadius: "50px",
            backgroundColor: Colors.white,
          }}
          disabled={isDisabled}
        >
          <MenuItem value={STRINGS.NO_SELECTION}>{STRINGS.NO_SELECTION}</MenuItem>
          <MenuItem value={STRINGS.TREATMENT_STATUS.TREATING}>
            {STRINGS.TREATMENT_STATUS.TREATING}
          </MenuItem>
          <MenuItem value={STRINGS.TREATMENT_STATUS.COMPLETE}>
            {STRINGS.TREATMENT_STATUS.COMPLETE}
          </MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}
